
<app-view-negative-market-slip
    [riskData]="riskData"
    [offersData]="slipData">
</app-view-negative-market-slip>
